export default{jobFavorites:{validateFavoritesApiURL:"/renderjob"}};